import React from 'react';
import Layout from '../components/Layout';

const cardStyle = {
  maxWidth: 600,
  margin: '3rem auto',
  background: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)',
  borderRadius: 18,
  boxShadow: '0 4px 24px 0 rgba(0, 200, 83, 0.12)',
  padding: '3rem 2.5rem',
  textAlign: 'center',
  border: '1.5px solid #A5D6A7',
};

const headingStyle = {
  color: '#1B5E20',
  fontSize: 32,
  fontWeight: 800,
  marginBottom: 16,
  letterSpacing: 1.2,
  textShadow: '0 2px 8px rgba(0, 200, 83, 0.08)',
};

const subText = {
  color: '#388E3C',
  fontSize: 18,
  marginBottom: 0,
  fontWeight: 500,
  opacity: 0.85,
};

const ReportsPage = () => (
  <Layout>
    <div style={cardStyle}>
      <h2 style={headingStyle}>Reports</h2>
      <p style={subText}>View and analyze your business performance in style.</p>
    </div>
  </Layout>
);

export default ReportsPage; 